import * as t from 'io-ts'

export const PictureId = t.readonly(t.strict({ id: t.string }))
export type PictureId = t.TypeOf<typeof PictureId>
